import { createEntityAdapter } from "@reduxjs/toolkit";

import type { UserAlertEntity } from "./types";

// UserAlertEntity already has an `id` field so it's not necessary to pass selectId
export const userAlertEntityAdapter = createEntityAdapter<UserAlertEntity>();
